export default "__VITE_ASSET__CwKpjXNe__"